export default __webpack_public_path__ + "locales/sk/CreateEditRoomDialog.json?hash=92c11c46cb4693d585dfe6814ead47b0";